import { render, staticRenderFns } from "./servicelogin.vue?vue&type=template&id=be41a70c&scoped=true&"
import script from "./servicelogin.vue?vue&type=script&lang=js&"
export * from "./servicelogin.vue?vue&type=script&lang=js&"
import style0 from "./servicelogin.vue?vue&type=style&index=0&id=be41a70c&prod&lang=css&"
import style1 from "./servicelogin.vue?vue&type=style&index=1&id=be41a70c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be41a70c",
  null
  
)

export default component.exports